export type EventItem = {
  slug: string;
  aliases?: string[];
  date: string;
  time: string;
  title: string;
  format: string;
  tags: string[];
  description: {
    de: string;
    en: string;
  };
  venue: string;
  address: string;
  city: string;
  artists: string[];
  flyer: string;
  registration: {
    maxAdditionalGuests: number;
  };
  admission: {
    registeredPrice: number;
    doorPrice: number;
    currency: "EUR";
    payment: "cash_on_site";
    drinksIncluded: false;
    minimumSpend: false;
    approvalRequired: true;
  };
};

export const upcomingEvents: EventItem[] = [
  {
    slug: "open-air-party-2026",
    aliases: ["pool-party-open-air-2026"],
    date: "2026-08-23",
    time: "16:00 — LATE",
    title: "Open Air Party",
    format: "Summer + Pool + Drink",
    tags: ["OPEN AIR", "SUMMER + POOL + DRINK"],
    description: {
      de: "Ein sommerliches AXON Open Air mit Pool-Atmosphäre, House und Afro House. Gemeinsam feiern wir von 16 Uhr bis spät in die Nacht bei Revolution in Neuss.",
      en: "A summer AXON open air with poolside energy, House and Afro House. Join us from 16:00 until late at Revolution in Neuss.",
    },
    venue: "Revolution",
    address: "Xantener Str. 7, 41460 Neuss",
    city: "Düsseldorf / Neuss",
    artists: ["M.O.R.E.S.", "Morra", "Fero", "Førzza", "Ayzen"],
    flyer: "/images/open-air-duesseldorf-2026.jpg",
    registration: {
      maxAdditionalGuests: 4,
    },
    admission: {
      registeredPrice: 10,
      doorPrice: 15,
      currency: "EUR",
      payment: "cash_on_site",
      drinksIncluded: false,
      minimumSpend: false,
      approvalRequired: true,
    },
  },
];

export function getEventBySlug(slug: string) {
  return upcomingEvents.find((event) => event.slug === slug || event.aliases?.includes(slug));
}
